"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingRequirements = exports.AdditionRefundExchangeDetailType = exports.OversizedLuggagePolicyType = exports.OversizedLuggageType = exports.RefundCreditType = exports.PolicyTypes = exports.BoardingRequirements = exports.TicketRequirementType = void 0;
var TicketRequirementType;
(function (TicketRequirementType) {
    TicketRequirementType["VOUCHER"] = "voucher";
    TicketRequirementType["CLAIM"] = "claim";
    TicketRequirementType["ETICKET"] = "eticket";
    TicketRequirementType["PRINT"] = "print";
    TicketRequirementType["SUPPLIER_EMAIL"] = "supplier-email";
    TicketRequirementType["ID_ONLY"] = "id-only";
})(TicketRequirementType = exports.TicketRequirementType || (exports.TicketRequirementType = {}));
var BoardingRequirements;
(function (BoardingRequirements) {
    BoardingRequirements["PRINTED_TICKET"] = "printed_tkt";
    BoardingRequirements["NONE"] = "none";
    BoardingRequirements["EXCHANGED_VOUCHER"] = "exchanged_voucher";
    BoardingRequirements["TICKET_REFERENCE_NUMBER"] = "tkt_ref_nb";
    BoardingRequirements["STATE_YOUR_NAME"] = "state_your_name";
    BoardingRequirements["PRINTED_OR_MOBILE_TICKET"] = "printed_or_mobile_tkt";
})(BoardingRequirements = exports.BoardingRequirements || (exports.BoardingRequirements = {}));
var PolicyTypes;
(function (PolicyTypes) {
    /** @deprecated Use ContactOperator */
    PolicyTypes["CallOperator"] = "call-operator";
    PolicyTypes["ContactOperator"] = "contact-operator";
    /** Used when the passenger must contact the operator before traveling, and not at the station */
    PolicyTypes["ContactOperatorBeforeTraveling"] = "contact-operator-before-traveling";
    PolicyTypes["External"] = "external";
    PolicyTypes["NoExchange"] = "no-exchange";
    PolicyTypes["NoRefund"] = "no-refund";
    PolicyTypes["SelfServe"] = "self-serve";
    PolicyTypes["Station"] = "station";
    PolicyTypes["Support"] = "support";
})(PolicyTypes = exports.PolicyTypes || (exports.PolicyTypes = {}));
var RefundCreditType;
(function (RefundCreditType) {
    /** A user is refunded on their original payment method */
    RefundCreditType["OriginalPaymentMethod"] = "original_payment_method";
    /** A user is refunded a voucher that can later be used on the supply operators platform to purchase a different ticket. */
    RefundCreditType["Voucher"] = "voucher";
    /** A customer is refunded with Busbud credits **/
    RefundCreditType["BusbudCredits"] = "busbud_credits";
})(RefundCreditType = exports.RefundCreditType || (exports.RefundCreditType = {}));
var OversizedLuggageType;
(function (OversizedLuggageType) {
    OversizedLuggageType["Bicycle"] = "bicycle";
    OversizedLuggageType["MusicalInstrument"] = "musical_instrument";
    OversizedLuggageType["SportingEquipment"] = "sport_equipment";
    OversizedLuggageType["Snowboard"] = "snowboard";
    OversizedLuggageType["Skis"] = "skis";
    OversizedLuggageType["Surfboard"] = "surfboard";
    OversizedLuggageType["OtherOversizedLuggage"] = "other_oversized_luggage";
})(OversizedLuggageType = exports.OversizedLuggageType || (exports.OversizedLuggageType = {}));
var OversizedLuggagePolicyType;
(function (OversizedLuggagePolicyType) {
    OversizedLuggagePolicyType["NotAllowed"] = "not_allowed";
    OversizedLuggagePolicyType["Free"] = "free";
    /** Flat fee that must be paid at the operator counter the day of departure. */
    OversizedLuggagePolicyType["FlatFee"] = "flat_fee";
    OversizedLuggagePolicyType["PayAtCheckout"] = "pay_at_checkout";
    OversizedLuggagePolicyType["AsCarryOnLuggage"] = "as_carry_on_luggage";
    OversizedLuggagePolicyType["AsAdditionalLuggage"] = "as_additional_luggage";
})(OversizedLuggagePolicyType = exports.OversizedLuggagePolicyType || (exports.OversizedLuggagePolicyType = {}));
var AdditionRefundExchangeDetailType;
(function (AdditionRefundExchangeDetailType) {
    AdditionRefundExchangeDetailType["ExternalOperatorTerms"] = "external_operator_terms";
})(AdditionRefundExchangeDetailType = exports.AdditionRefundExchangeDetailType || (exports.AdditionRefundExchangeDetailType = {}));
var BookingRequirements;
(function (BookingRequirements) {
    /** clients should ensure that the T&Cs are explicitly agreed to before being able to make their purchase */
    BookingRequirements["ExplicitOptIn"] = "explicit_opt_in";
})(BookingRequirements = exports.BookingRequirements || (exports.BookingRequirements = {}));
//# sourceMappingURL=fare-types.js.map